import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="font-sans bg-gray-50 min-h-screen flex flex-col">
      <Header isStatic={true} />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 border border-gray-100">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Política de Privacidad</h1>
          <p className="text-gray-500 mb-8 pb-4 border-b border-gray-100">Última actualización: 9 de marzo de 2026</p>

          <div className="prose prose-blue max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Información que Recopilamos</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">1.1 Información Personal</h3>
                  <p>Recopilamos información que usted nos proporciona directamente al registrarse o utilizar la aplicación:</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li><strong>Nombre y Apellido:</strong> Para identificarlo como socio del gimnasio.</li>
                    <li><strong>Correo Electrónico:</strong> Para la autenticación de su cuenta y comunicaciones relacionadas con el servicio.</li>
                    <li><strong>Número de Teléfono:</strong> Para contacto de emergencia o notificaciones importantes del gimnasio.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-800">1.2 Datos de Salud y Fitness</h3>
                  <p>Para proporcionarle nuestras funciones de entrenamiento, recopilamos:</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li><strong>Rutinas de Ejercicio:</strong> Detalle de los ejercicios asignados por su entrenador.</li>
                    <li><strong>Progreso del Entrenamiento:</strong> Pesos, repeticiones, series y marcas de ejercicios completados.</li>
                    <li><strong>Asistencia:</strong> Registro de sus visitas al gimnasio.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-800">1.3 Información Financiera</h3>
                  <p><strong>Historial de Pagos y Membresías:</strong> Registramos el estado de sus cuotas y planes vigentes para garantizar su acceso a las instalaciones. <em>Nota: No almacenamos directamente datos de tarjetas de crédito; los pagos se procesan a través de plataformas seguras de terceros.</em></p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-800">1.4 Datos del Dispositivo</h3>
                  <p>Podemos recopilar identificadores únicos de dispositivo para el funcionamiento técnico de la aplicación y el envío de notificaciones push.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Uso de la Información</h2>
              <p>Utilizamos la información recopilada para:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Proporcionar y mantener la funcionalidad de la aplicación.</li>
                <li>Permitirle seguir su progreso físico y visualizar sus rutinas.</li>
                <li>Gestionar su membresía y pagos en el gimnasio.</li>
                <li>Comunicarnos con usted sobre actualizaciones o cambios en el servicio.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Almacenamiento y Seguridad</h2>
              <p>Sus datos se almacenan de forma segura en nuestros servidores y, en el caso de la aplicación móvil, se utilizan mecanismos de almacenamiento local seguro (como SecureStore) para proteger sus credenciales de acceso. Implementamos medidas técnicas y organizativas para proteger su información contra pérdida, robo o acceso no autorizado.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Compartir Información</h2>
              <p><strong>No compartimos ni vendemos su información personal a terceros con fines comerciales.</strong> Sus datos solo son accesibles por usted y por el personal autorizado del gimnasio al que pertenece para gestionar su entrenamiento y membresía.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Sus Derechos</h2>
              <p>Usted tiene derecho a:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Acceder a sus datos personales almacenados en la aplicación.</li>
                <li>Solicitar la corrección de datos inexactos.</li>
                <li>Solicitar la eliminación de su cuenta y datos asociados, contactando a la administración de su gimnasio o a través de nuestros canales de soporte.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Eliminación de Cuenta y Datos</h2>
              <p>De acuerdo con las políticas de Google Play y Apple App Store, proporcionamos métodos directos para solicitar la eliminación de su cuenta y los datos asociados:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li><strong>Eliminación Inmediata (Autogestión):</strong> Usted puede eliminar de manera definitiva e inmediata su cuenta móvil, credenciales y vinculaciones ingresando a nuestro portal seguro: <br/><a href="https://api.multigym.com.ar/delete-account" className="text-blue-600 hover:underline font-medium">➡️ Portal de Eliminación de Cuenta</a>.</li>
                <li><strong>Solicitud Vía Correo:</strong> Alternativamente, puede solicitar la eliminación definitiva de su cuenta enviando un correo electrónico a <a href="mailto:info@multigym.com.ar" className="text-blue-600 hover:underline">info@multigym.com.ar</a> con el asunto "Solicitud de eliminación de cuenta". En este caso procesaremos su solicitud en un plazo máximo de 72 horas hábiles.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Contacto</h2>
              <p>Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos en:</p>
              <ul className="list-none mt-2 space-y-2">
                <li><strong>Sitio Web:</strong> <a href="https://multigym.com.ar" className="text-blue-600 hover:underline">https://multigym.com.ar</a></li>
                <li><strong>Correo Electrónico:</strong> <a href="mailto:info@multigym.com.ar" className="text-blue-600 hover:underline">info@multigym.com.ar</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
